/* eslint-disable import/first */
import React, {Component} from 'react';
import Modal from 'react-modal';
import _ from 'lodash';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ActionModalShow, ActionModalHide} from '../../store/actions/actions-modal';

class ModalBaseLayout extends Component {
  static getInitialSettings(params) {
    const defaultSettings = {
      className: '',
      backdrop: true,
      closeButton: true,
      onClose: null,
    };

    return {...defaultSettings, ...params};
  }

  hideModal = (e, callback) => {
    this.props.ActionModalHide(callback && _.isFunction(callback) && callback || this.props.onClose);
  };

  render() {
    return (
      <Modal
        className={this.props.className || ''}
        isOpen={!!this.props.rModals.templateType}
        onHide={this.hideModal}
        backdrop={this.props.backdrop}
      >
        <div className="modal-backdrop" onClick={this.hideModal} />
        <div className="modal-main-content">
          <div className="modal-inner">
            {this.props.children}
          </div>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps({rModals}) {
  return {
    rModals,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalShow,
    ActionModalHide,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalBaseLayout);
